
function initalSurvey(state, data){
    state.type = data.type;
    state.geo = data.geo;
}

export default {
    initalSurvey
};
